import { Component, OnInit, Input, Output, EventEmitter, PipeTransform, Pipe, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core'
import { Observable } from 'rxjs'
import { removeInArray } from '../../util'

export enum HelpStructure {
  table,
  treeTable,
  transfer,
  treeTransfer
}
export declare type HelpGetData<T> = (() => Observable<T[]>) | Observable<T[]> | T[]

@Component({
  selector: 'wdesgin-help-shell',
  templateUrl: './help-shell.component.html',
  styleUrls: ['./help-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpShellComponent<T> implements OnInit {
  // @Input() data: T[]
  @Input() getData: HelpGetData<T> = []
  // @Input() getTree: () => Observable<T[]>
  @Input() getTableOnSelectTree: (node) => Observable<T[]>
  @Input() tableFields = []
  @Input() structure: HelpStructure = HelpStructure.table
  @Output() selectDataItem = new EventEmitter<T>()
  @Input() expandedKeys = []

  data: T[]
  filteredData: T[]
  selectedDataItem: T
  HelpStructure = HelpStructure

  constructor (private cd: ChangeDetectorRef) { }

  ngOnInit () {
    if (typeof this.getData === 'function') {
      this.getData().subscribe(data => {
        this.data = data
        this.cd.markForCheck()
      })
    } else if (this.getData['subscribe']) {
      (this.getData as Observable<T[]>).subscribe(data => {
        this.data = data
        this.cd.markForCheck()
      })
    } else if (typeof this.getData['length'] === 'number') {
      this.data = this.getData as T[]
    }
    // else if (this.structure === HelpStructure.treeTable) {
    //   this.getTree().subscribe(tree => this.tree = tree)
    // }
  }

  /** table */
  handleSearch (searchString) {
    if (!searchString) {
      this.filteredData = null
      return
    }
    this.filteredData = this.data.filter(item => {
      // return Object.values(item).some(v => v && v.indexOf && v.indexOf(searchString) > -1)
      return this.tableFields.some(e => item[e] && item[e].indexOf(searchString) > -1)
    })
  }

  handleClickItem (dataItem: T) {
    this.selectedDataItem = dataItem
  }
  handleDbClickItem (dataItem: T) {
    this.selectDataItem.emit(dataItem)
  }


  /** tree table, tree transfer */
  // tree: any[]
  tableData: T[] = []
  loadingTable = false

  /**
   * 两种右侧列表数据来源：
   * 1. 藏在树的 children 中，需要指定父节点为 isTableParent
   * 2. 实现 getTableOnSelectTree 事件，点击节点时，返回一个取数的 observable
   */
  handleClickTreeNode (e) {
    this.loadingTable = true
    // TODO: cache
    if (this.getTableOnSelectTree) {
      const obs = this.getTableOnSelectTree(e.node.origin)
      if (obs) obs.subscribe(this.setTableData.bind(this))
    }
    // TODO: 整理字段
    if (e.node.origin.isTableParent) this.setTableData(e.node.origin.children)
  }

  setTableData (data: T[]) {
    this.tableData = data
    this.loadingTable = false
    this.cd.markForCheck()
  }

  /** tree transfer */
  checkedItems = []

  handleClickCheckAllRightTable (checkedAll: boolean) {
    if (checkedAll) {
      this.tableData.forEach(item => {
        if (!this.getIfChecked(item)) this.checkedItems.push(item)
      })
    } else {
      this.tableData.forEach(i => this.removeCheckedItem(i))
    }
  }
  handleClickCheckItem (item) {
    if (this.getIfChecked(item)) {
      this.removeCheckedItem(item)
    } else {
      this.checkedItems.push(item)
    }
  }
  removeCheckedItem (dataItem) {
    removeInArray(this.checkedItems, checkedItem => checkedItem.id === dataItem.id)
  }

  // 较高频调用
  getIfChecked (item) {
    return this.checkedItems.some(i => i.id === item.id)
  }
  getIfAllChecked () {
    return this.tableData.length > 0 ? this.tableData.every(this.getIfChecked.bind(this)) : false
  }

}

@Pipe({ name: 'dataPath' })
export class DataPathPipe implements PipeTransform {
  transform (data: any[], path: string | string[]): any {
    if (typeof path === 'string') return data[path]
    if (path.pop) {
      let dataPart = { ...data }
      path.forEach(pathPart => {
        dataPart = dataPart[pathPart]
      })
      return dataPart
    }
  }
}
